import React, { Component } from 'react'
import _ from 'lodash'
import { observer, inject } from 'mobx-react'
import { Row, Col, Modal } from 'antd'
import { compose } from 'recompose'
import PDFViewer from 'pdf-viewer-reactjs'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
		}
	}

	render() {
		const { visible, onCancel, file_url } = this.props
		return (
			<Modal
				title='Action Details'
				width='80%'
				visible={visible}
				onCancel={onCancel}
				onOk={() => {
					window.open(`${process.env.REACT_APP_BACKEND_API}${file_url}`, '_blank')
				}}
				okText='Print'
				destroyOnClose
			>
				<div style={{ backgroundColor: 'gray', paddingTop: 50 }}>
					<PDFViewer
						document={{
							url: `${process.env.REACT_APP_BACKEND_API}${file_url}`,
						}}
					/>
				</div>
			</Modal>
		)
	}
}

const composed = compose(
	inject('AuthStore'),
	observer
)

export default composed(Index)